import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import loader from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";
import { Modal, Button, Form, Alert } from "react-bootstrap";

const optionConsumptionType = [
  { value: "111260002", label: "Item" },
  { value: "", label: "Equipment" },
]

// Options for the dropdown
const options = [
  { value: "111260000", label: "Faulty" },
  { value: "111260001", label: "Replace" },
  { value: "111260002", label: "Deactivate" },
  { value: "111260003", label: "NA" },
];




const YourAssignmentAddItem = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // Remove box shadow
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "black",
      fontSize: "18px", // Increased text size
    }),
    inputFocused: {
      boxShadow: "none",
      fontSize: "18px", // Increased text size
    },
  };

  const [loading, setLoading] = useState(false);
  const [activeForm, setActiveForm] = useState("form3");
  const [consumptionType, setConsumptionType] = useState();
  const [item, setItem] = useState("");
  const [subItem, setSubItem] = useState("");
  const [itemType, setItemType] = useState("");
  const [nrgpItem, setNrgpItem] = useState("");
  const [nrgpSubItem, setNrgpSubItem] = useState("");
  const [addItemData, setAddItemData] = useState({
    quantity: "",
    serialNo: "",
    macId: "",
    nrgp: "",
    nrgpSerialNum: ""
  });
  const [locationCode, setLocationCode] = useState(null);
  const handleLocationChange = (selectedOption) => {
    setLocationCode(selectedOption);
  };
  const [locationOptions, setLocationOptions] = useState([]);

  const [optionItem, setOptionItem] = useState([]);
  const [optionSubItem, setOptionSubItem] = useState([]);
  const [optionItemType, setOptionItemType] = useState([]);
  const [optionNrgpItem, setOptionNrgpItem] = useState([]);
  const [optionNrgpSubItem, setOptionNrgpSubItem] = useState([]);
  const [templateID, setTemplateID] = useState("");
  const [nrgp, setNrgp] = useState("");
  const [showConsumptionTable, setShowConsumptionTable] = useState(false);
  const [consumptionData, setConsumptionData] = useState([]);
  const [showReplaceFields, setShowReplaceFields] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isReplaceClicked, setIsReplaceClicked] = useState(false);

  const [itemGUID, setItemGUID] = useState(null);
  const [subItemGUID, setSubItemGUID] = useState(null);
  // const [selectedRow, setSelectedRow] = useState(null);
  const [editModal, setEditModal] = useState(false);


  const [serialOptions, setSerialOptions] = useState([]);
  const [selectedSerial, setSelectedSerial] = useState(null);
  const [reasonType, setReasonType] = useState(null);


  const [erpIssues, setErpIssues] = useState([]);
  // const style = {}; // Define your react-select custom styles here


  // Handler function to update state on selection change
  const handleReasonType = selectedOption => {
    setReasonType(selectedOption);
  };

  const fetchItemMaster = async (selectConsumption) => {
    setConsumptionType(selectConsumption);
    // setLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "getAllItemMasterFromCRM",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        CanId: sessionStorage.getItem("CanId"),
        Master: "true",
        SrNumber: sessionStorage.getItem("ViewSR"),
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();
      // Depending on the consumption type, set the options accordingly
      if (selectConsumption === "Item") {
        setOptionItem(result.Response.item);
        setOptionSubItem(result.Response.item)
      } else {
        setOptionItem(result.Response.equipment);
        setOptionSubItem(result.Response.item)
      }
    } catch (error) {
      console.error("Error fetching getAllItemMasterFromCRM:", error);
    } finally {
      // setLoading(false);
    }
  };


  // const fetchErpIssues = async () => {
  //   try {
  //     // Replace with your ERP API endpoint if different
  //     const apiUrl = process.env.REACT_APP_API_URL;
  //     const requestData = {
  //       Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //       Action: "getissuelistERP",
  //       filter: [
  //         {
  //           Criteria: sessionStorage.getItem("userName") + "|" + "IN\\" + sessionStorage.getItem("reportingManager")
  //           ,
  //         }
  //       ],
  //     };
  //     const response = await fetch(apiUrl, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(requestData),
  //     });

  //     const textResponse = await response.text();

  //     // Parse the SOAP XML response using DOMParser
  //     const parser = new DOMParser();
  //     const xmlDoc = parser.parseFromString(textResponse, "text/xml");
  //     const issueNodes = xmlDoc.getElementsByTagName("GetissueList");
  //     let issues = [];

  //     // Loop through each <GetissueList> element and extract the needed fields
  //     for (let i = 0; i < issueNodes.length; i++) {
  //       const node = issueNodes[i];
  //       const itemNo = node.getElementsByTagName("Item_No")[0]?.textContent;
  //       const serialNo = node.getElementsByTagName("Serial_No")[0]?.textContent;
  //       const lotNo = node.getElementsByTagName("Lot_No")[0]?.textContent;
  //       issues.push({
  //         Item_No: itemNo,
  //         Serial_No: serialNo,
  //         Lot_No: lotNo || "",
  //       });
  //     }
  //     setErpIssues(issues);
  //   } catch (error) {
  //     console.error("Error fetching ERP issues:", error);
  //   }
  // };



  // const handleItem = (selectedOption) => {
  //   setItem(selectedOption);
  //   const relatedSubItem = optionItem.find(data => data.item_code === selectedOption.value);
  //   const tmpID = optionItem.find(data => data.item_code === selectedOption.value);

  //   if (relatedSubItem) {
  //     setSubItem({ value: relatedSubItem.sub_item_code, label: relatedSubItem.sub_item_name });
  //     setTemplateID(tmpID.TemplateId)
  //     setNrgpItem(tmpID.NRGPItemID)
  //     setNrgp(tmpID.NRGP)
  //     setItemType(tmpID.ItemType)
  //   }
  //   // Find the matching ERP issue record by comparing the item code.
  //   // Note: Make sure that the 'value' of your option (data.item_code)
  //   // exactly matches the ERP response's <Item_No> value.
  //   const matchingIssue = erpIssues.find(

  //     (issue) => issue.Item_No === selectedOption.value1
  //   );
  //   console.log("123:", erpIssues.find(

  //     (issue) => issue.Item_No));
  //   console.log("12345", selectedOption.value);


  //   if (matchingIssue) {
  //     // Use Serial_No; if that's not available, use Lot_No
  //     const serialValue = matchingIssue.Serial_No || matchingIssue.Lot_No || "";
  //     setAddItemData((prevData) => ({
  //       ...prevData,
  //       serialNo: serialValue,
  //     }));
  //   } else {
  //     // If no matching record, clear the field
  //     setAddItemData((prevData) => ({
  //       ...prevData,
  //       serialNo: "",
  //     }));
  //   }
  // };


  const PrimaryEmail = sessionStorage.getItem('PrimaryEmail')
  const businessEmails = [
    "loganathan.s@spectra.co",
    "haridoss.r@spectra.co"
  ];
 
 
  const fetchErpIssues = () => {
    if (businessEmails.includes(PrimaryEmail)) {
      fetchErpIssues2();
    } else if (PrimaryEmail === "kannadhasan1@spectra.co") {
      fetchErpIssues3();
    } else {
      fetchErpIssues1();
    }
  }
  const fetchErpIssues3 = async () => {
    try {
      // Replace with your ERP API endpoint if different
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        Action: "getissuelistERP",
        filter: [
          {
            Criteria: sessionStorage.getItem("userName") + "|" + "IN\\" + "selvabalaji.h"
            ,
          }
        ],
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
 
      const textResponse = await response.text();
 
      // Parse the SOAP XML response using DOMParser
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(textResponse, "text/xml");
      const issueNodes = xmlDoc.getElementsByTagName("GetissueList");
      let issues = [];
 
      // Loop through each <GetissueList> element and extract the needed fields
      for (let i = 0; i < issueNodes.length; i++) {
        const node = issueNodes[i];
        const itemNo = node.getElementsByTagName("Item_No")[0]?.textContent;
        const serialNo = node.getElementsByTagName("Serial_No")[0]?.textContent;
        const lotNo = node.getElementsByTagName("Lot_No")[0]?.textContent;
        issues.push({
          Item_No: itemNo,
          Serial_No: serialNo,
          Lot_No: lotNo || "",
        });
      }
      setErpIssues(issues);
    } catch (error) {
      console.error("Error fetching ERP issues:", error);
    }
  };
  const fetchErpIssues2 = async () => {
    try {
      // Replace with your ERP API endpoint if different
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        Action: "getissuelistERP",
        filter: [
          {
            Criteria: sessionStorage.getItem("userName") + "|" + "IN\\" + "THANUVALINGAM.VEERA"
            ,
          }
        ],
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
 
      const textResponse = await response.text();
 
      // Parse the SOAP XML response using DOMParser
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(textResponse, "text/xml");
      const issueNodes = xmlDoc.getElementsByTagName("GetissueList");
      let issues = [];
 
      // Loop through each <GetissueList> element and extract the needed fields
      for (let i = 0; i < issueNodes.length; i++) {
        const node = issueNodes[i];
        const itemNo = node.getElementsByTagName("Item_No")[0]?.textContent;
        const serialNo = node.getElementsByTagName("Serial_No")[0]?.textContent;
        const lotNo = node.getElementsByTagName("Lot_No")[0]?.textContent;
        issues.push({
          Item_No: itemNo,
          Serial_No: serialNo,
          Lot_No: lotNo || "",
        });
      }
      setErpIssues(issues);
    } catch (error) {
      console.error("Error fetching ERP issues:", error);
    }
  };
  const fetchErpIssues1 = async () => {
    try {
      // Replace with your ERP API endpoint if different
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        Action: "getissuelistERP",
        filter: [
          {
            Criteria: sessionStorage.getItem("userName") + "|" + "IN\\" + sessionStorage.getItem("reportingManager")
            ,
          }
        ],
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
 
      const textResponse = await response.text();
 
      // Parse the SOAP XML response using DOMParser
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(textResponse, "text/xml");
      const issueNodes = xmlDoc.getElementsByTagName("GetissueList");
      let issues = [];
 
      // Loop through each <GetissueList> element and extract the needed fields
      for (let i = 0; i < issueNodes.length; i++) {
        const node = issueNodes[i];
        const itemNo = node.getElementsByTagName("Item_No")[0]?.textContent;
        const serialNo = node.getElementsByTagName("Serial_No")[0]?.textContent;
        const lotNo = node.getElementsByTagName("Lot_No")[0]?.textContent;
        issues.push({
          Item_No: itemNo,
          Serial_No: serialNo,
          Lot_No: lotNo || "",
        });
      }
      setErpIssues(issues);
    } catch (error) {
      console.error("Error fetching ERP issues:", error);
    }
  };

  const handleItem = (selectedOption) => {
    setItem(selectedOption);
    const relatedSubItem = optionItem.find(data => data.item_code === selectedOption.value);
    const tmpID = optionItem.find(data => data.item_code === selectedOption.value);

    if (relatedSubItem) {
      setSubItem({ value: relatedSubItem.sub_item_code, label: relatedSubItem.sub_item_name });
      setTemplateID(tmpID.TemplateId)
      setNrgpItem(tmpID.NRGPItemID)
      setNrgp(tmpID.NRGP)
      setItemType(tmpID.ItemType)
    }
    // Filter ERP issues to only those with a matching Item_No
    const matchingIssues = erpIssues.filter(
      (issue) => issue.Item_No === selectedOption.value1
    );

    // Map matching issues into dropdown options using Serial_No (or Lot_No as fallback)
    const serialOpt = matchingIssues.map((issue) => {
      const serialVal = issue.Serial_No || issue.Lot_No || "";
      return {
        value: serialVal,
        label: serialVal,
      };
    });

    setSerialOptions(serialOpt);
    // Clear any previously selected serial option
    setSelectedSerial(null);
  };



  // useEffect(() => {

  // }, []);

  // Load item master data when the component mounts or when consumption type changes
  useEffect(() => {
    fetchErpIssues();
    fetchItemMaster(consumptionType);
  }, [consumptionType]);


  const handleReturn = async (row) => {
    setEditModal(true);
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;

      const getItemPayload = {
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        Action: "getItemForDefaultBOQ",
        ItemCode: row.ItemCode,
      };

      const getItemResponse = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(getItemPayload),
      });

      const getItemResult = await getItemResponse.json();
      // console.log("getItemForDefaultBOQ response:", getItemResult);

      if (getItemResult.Status === "Success" && getItemResult.Response) {
        const { ItemGUID, SubItemGUID } = getItemResult.Response;
        setItemGUID(ItemGUID);
        setSubItemGUID(SubItemGUID);
        setSelectedRow(row);
        // Open modal popup
      } else {
        toast.warning(
          getItemResult.Message || "Failed to fetch item for default BOQ",
          { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
        );
      }
    } catch (error) {
      console.error("Error in Return process:", error);
      toast.error("Error in returning item", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    setLoading(false);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;

      // Process serial number and quantity from selected row
      const serialNumber = Array.isArray(selectedRow.SerialNo)
        ? selectedRow.SerialNo.length > 0
          ? selectedRow.SerialNo.join(", ")
          : ""
        : selectedRow.SerialNo || "";

      let quantity = selectedRow.QtyConsumed || "";
      if (quantity !== "") {
        const parsedQuantity = parseFloat(quantity);
        if (!isNaN(parsedQuantity)) {
          quantity =
            parsedQuantity === Math.floor(parsedQuantity)
              ? parsedQuantity.toString()
              : parsedQuantity.toString();
        }
      }
      const oldFaultyDevice = selectedRow.LotNo || "";

      const createPayload = {
        Action: "createItemInCRM",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        srNumber: sessionStorage.getItem("ViewSR"),
        canId: sessionStorage.getItem("CanId"),
        userId: "IN\\" + sessionStorage.getItem("userName"),
        TLName: "IN\\" + sessionStorage.getItem("reportingManager"),
        item: {},
        equipment: {},
        defaultBOQ: {
          ItemType: "Default",
          SerialNumber: serialNumber || oldFaultyDevice, // from row.SerialNo if available
          Quantity: quantity,
          ItemCodeForBOQ: selectedRow.ItemCode,
          Item: itemGUID, // from getItemForDefaultBOQ response
          SubItem: subItemGUID, // from getItemForDefaultBOQ response
          ConsumptionType: "111260002",
          MacId: "",
          NRGPSerialNumber: "",
          NRGP: "false",
          NRGPItem: "",
          TemplateID: "",
          // Use dropdown selections
          LocationCode: locationCode ? locationCode.value : "",
          Adaptor: adaptor ? adaptor.value : "",
          Reasonofreplacement: reasonOfReplacement ? reasonOfReplacement.value : "",
          Oldfaultydevice: "",
          ReplacementType: "111260001",
        },
      };

      const createResponse = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(createPayload),
      });

      const createResult = await createResponse.json();
      // console.log("createItemInCRM response:", createResult);

      if (createResult.Status === "Success") {
        toast.success("Item Returned in CRM successfully!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setEditModal(false); // Close the modal on success
      } else {
        toast.warning(
          createResult.Message || "Failed to return item in CRM",
          { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
        );
      }
    } catch (error) {
      console.error("Error in Update process:", error);
      toast.error("Error in updating item", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    setLoading(false);
  };


  useEffect(() => {
    const fetchLocationOptions = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_API_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            Action: "getLocationCode",
          }),
        });
        const result = await response.json();
        if (result && result.Status === "Success" && result.Response?.Data) {
          setLocationOptions(result.Response.Data);
        } else {
          toast.warning("No location data", { autoClose: 1500 });
        }
      } catch (error) {
        toast.error("Error fetching location options");
      }
    };
    fetchLocationOptions();
  }, []);
  const ConsumptionTable = () => {
    // alert("Done!");

    const handleReplace = (itemCode) => {
      alert(`Replace item: ${itemCode}`);
      // You can add further logic here, e.g., navigate to another page or open a modal.
    };

    return (
      <div className="p-4">
        <h2 className="text-lg font-semibold mb-4">Consumption Details</h2>
        <div className="overflow-x-auto">
          <table className="w-full border border-gray-300 rounded-lg">
            <thead>
              <tr className="bg-gray-200">
                <th className="p-2 border">CAN ID</th>
                <th className="p-2 border">Item Code</th>
                <th className="p-2 border">Description</th>
                <th className="p-2 border">Consumption Date</th>
                <th className="p-2 border">Quantity</th>
                <th className="p-2 border">Serial No</th>
                <th className="p-2 border">Lot No</th>
                <th className="p-2 border">Customer Name</th>
                <th className="p-2 border">Action</th>
              </tr>
            </thead>
            <tbody>
              {[
                {
                  canId: "2317710",
                  itemCode: "CE-ITEM/0008",
                  description: "ADAPTER FOR CPE",
                  date: "10/04/21",
                  quantity: "1.00",
                  serialNo: "-",
                  lotNo: "LOT/20-21/000619",
                  customer: "Nostri Design Consultants Private Limited",
                },
                {
                  canId: "2317710",
                  itemCode: "OC-ITEM/00016",
                  description: "FIBER TERMINATION BOX",
                  date: "10/04/21",
                  quantity: "1.00",
                  serialNo: "-",
                  lotNo: "LOT/21-22/000246",
                  customer: "Nostri Design Consultants Private Limited",
                },
                {
                  canId: "2317710",
                  itemCode: "CE-ITEM/0001",
                  description: "D- LINK - 825",
                  date: "10/04/21",
                  quantity: "1.00",
                  serialNo: "TR3R10A000960",
                  lotNo: "-",
                  customer: "Nostri Design Consultants Private Limited",
                },
              ].map((item, index) => (
                <tr key={index} className="hover:bg-gray-100">
                  <td className="p-2 border">{item.canId}</td>
                  <td className="p-2 border">{item.itemCode}</td>
                  <td className="p-2 border">{item.description}</td>
                  <td className="p-2 border">{item.date}</td>
                  <td className="p-2 border">{item.quantity}</td>
                  <td className="p-2 border">{item.serialNo}</td>
                  <td className="p-2 border">{item.lotNo}</td>
                  <td className="p-2 border">{item.customer}</td>
                  <td className="p-2 border">
                    <button
                      onClick={() => handleReplace(item.itemCode)}
                      className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-700"
                    >
                      Replace
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };




  const handleChange = (e) => {
    // console.log(e.target.name, e.target.value);
    setAddItemData({ ...addItemData, [e.target.name]: e.target.value });
  };

  const handleConsumptionType = async (selectConsumption) => {
    setConsumptionType(selectConsumption)
    // console.log("selectConsumption", selectConsumption)
    // try {
    //   setLoading(true);
    //   const apiUrl = process.env.REACT_APP_API_URL;
    //   const requestData = {
    //     "Action": "getAllItemMasterFromCRM",
    //     "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    //     "CanId": sessionStorage.getItem("CanId"),
    //     // "CanId": "9060885",

    //     "Master": "true",
    //     "SrNumber": sessionStorage.getItem("ViewSR")
    //     // "SrNumber": "SR22082532811"

    //   }
    //   const response = await fetch(apiUrl, {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify(requestData),
    //   });
    //   const result = await response.json();
    //   console.log("getAllItemMasterFromCRM", result)
    //   console.log("result.Response.item.TemplateId", result.Response.item);

    //   if (selectConsumption.label === "Item") {
    //     setOptionItem(result.Response.item);
    //     setOptionSubItem(result.Response.item);
    //     setOptionItemType(result.Response.item);
    //     setOptionNrgpItem(result.Response.item);
    //     setOptionNrgpSubItem(result.Response.item);
    //     setTemplateID(result.Response.item.TemplateId)
    //   } else {
    //     setOptionItem(result.Response.equipment);
    //     setOptionSubItem(result.Response.equipment);
    //     setOptionItemType(result.Response.equipment);
    //     setOptionNrgpItem(result.Response.equipment);
    //     setOptionNrgpSubItem(result.Response.equipment);
    //     setTemplateID(result.Response.equipment.TemplateId);
    //   }

    // } catch (error) {
    //   console.error("Error fetching getAllItemMasterFromCRM:", error);
    // } finally {
    //   setLoading(false);
    // }
  }



  const handleItem1 = (selectItem) => {
    setItem(selectItem); // Set the selected item
    // Find the related sub-item based on the selected item
    const relatedSubItem = optionItem.find(data => data.item_code === selectItem.value);
    const tmpID = optionItem.find(data => data.item_code === selectItem.value);
    // console.log("tmpID",tmpID)
    // If a related sub-item exists, set it as the selected sub-item
    if (relatedSubItem) {
      setSubItem({ value: relatedSubItem.sub_item_code, label: relatedSubItem.sub_item_name });
      setTemplateID(tmpID.TemplateId)
      setNrgpItem(tmpID.NRGPItemID)
      setNrgp(tmpID.NRGP)
      setItemType(tmpID.ItemType)
    }
  };

  // const handleSubItem = (selectSubItem) => {
  //   setSubItem(selectSubItem); // Manually handle sub-item selection if needed
  // };

  const handleSubItem = (selectSubItem) => {
    setSubItem(selectSubItem); // Manually handle sub-item selection if needed
    const matchingIssues = erpIssues.filter(
      (issue) => issue.Item_No === selectSubItem.value1
    );
    // console.log("subitem0",selectSubItem.value1);
 
    // console.log("subitem",matchingIssues);
 
    // Map matching issues into dropdown options using Serial_No (or Lot_No as fallback)
    const serialOpt = matchingIssues.map((issue) => {
      const serialVal = issue.Serial_No || issue.Lot_No || "";
      return {
        value: serialVal,
        label: serialVal,
      };
    });
 
    setSerialOptions(serialOpt);
   
    setSelectedSerial(null);
  };

  const handleItemType = (selectItem) => {
    setItemType(selectItem);
  }
  const handleNrgpItem = (selectNrgpItem) => {
    setNrgpItem(selectNrgpItem);
  }
  const handleNrgpSubItem = (selectNrgpSubItem) => {
    setNrgpSubItem(selectNrgpSubItem);
  }

  const navigate = useNavigate();
  const redirectDashboardPage = () => {
    navigate("/dashboard");
  };



  const handleCreateEquipment1 = () => {

    if (selectedSerial === null || !selectedSerial.value) {
      toast.warning("Please select Serial/Lot No.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      // alert('102')

    } else {
      handleCreateEquipment();
    }
  };


  const handleCreateEquipment = async () => {


    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;


      const isItemConsumption = consumptionType?.label === "Item";

      let defaultBOQ = [];
      if (selectedRow) {

        defaultBOQ = consumptionData.map((record) => ({


          // Adaptor: adaptor?.value || "",
          // LocationCode: locationCode?.value || "",
          Adaptor:
            selectedRow &&
              record.ItemCode === selectedRow.ItemCode &&
              record.SerialNo === selectedRow.SerialNo
              ? (adaptor?.value || "")
              : "",
          LocationCode: selectedRow &&
            record.ItemCode === selectedRow.ItemCode &&
            record.SerialNo === selectedRow.SerialNo
            ? (locationCode?.value || "")
            : "",
          ConsumptionType: "111260002",
          ItemCodeForBOQ: record.ItemCode,
          ItemType: "Default",
          MacId: "01",
          NRGP: "false",
          NRGPItem: null,
          NRGPSerialNumber: "",
          Oldfaultydevice: null,
          Reason: reasonType?.value,
          Quantity: record.QtyConsumed
            ? record.QtyConsumed.toString().replace(/\.00$/, "")
            : record.QtyConsumed,
          Reasonofreplacement: selectedRow &&
            record.ItemCode === selectedRow.ItemCode &&
            record.SerialNo === selectedRow.SerialNo
            ? (reasonOfReplacement?.value || "")
            : "",
          ReplacementType:
            selectedRow &&
              record.ItemCode === selectedRow.ItemCode &&
              record.SerialNo === selectedRow.SerialNo
              ? "111260000"
              : "",

          SerialNumber: Array.isArray(record.SerialNo)
            ? record.SerialNo.length > 0
              ? record.SerialNo.join(", ")
              : ""
            : record.SerialNo || "",

          LotCode: Array.isArray(record.LotNo)
            ? record.LotNo.length > 0
              ? record.LotNo.join(", ")
              : ""
            : record.LotNo || "",
          TemplateID: null,
          TemplateID: null,
        }));
      }

      const computedSerialValueForItemData = selectedRow
        ? ((Array.isArray(selectedRow.SerialNo)
          ? selectedRow.SerialNo.length > 0
            ? selectedRow.SerialNo.join(", ")
            : ""
          : selectedRow.SerialNo || "") || (selectedRow.LotNo || ""))
        : "";

      // Build item data from the form values
      const itemData = {
        Adaptor: adaptor?.value || "",
        ConsumptionType: "111260002",
        Item: item?.value || "",
        ItemType: isReplaceClicked ? "Default" : "Additional",
        LocationCode: locationCode?.value || "",
        MacId: "01",
        NRGP: "false",
        NRGPItem: nrgpItem || "",
        NRGPSerialNumber: addItemData.nrgpSerialNum || "",
        Oldfaultydevice: computedSerialValueForItemData || "",
        Quantity: addItemData.quantity || "",
        Reasonofreplacement: reasonOfReplacement?.value || "",
        ReplacementType: isReplaceClicked ? "111260000" : "",
        SerialNumber: selectedSerial?.value || "",
        SubItem: subItem?.value || "",
        TemplateID: null,
      };

      // Prepare the final request payload
      const requestData = {
        Action: "createItemInCRM",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        userId: "IN\\" + sessionStorage.getItem("userName"),
        TLName: "IN\\" + sessionStorage.getItem("reportingManager"),
        // srNumber: "SR22082532811",
        // canId: "9060885",
        srNumber: sessionStorage.getItem("ViewSR"),
        canId: sessionStorage.getItem("CanId"),
        defaultBOQ: defaultBOQ,
        equipment: isItemConsumption ? {} : itemData,
        item: isItemConsumption ? itemData : {},
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      // console.log("createItemEquipment requestData", requestData);
      // alert('10')
      const result = await response.json();
      // console.log("createItemEquipment", result);
      navigate("/materialConsumeStatus");
    } catch (error) {
      console.error("Error fetching createItemEquipment:", error.message, error);
    } finally {
      setLoading(false);
      // alert('101')
    }
  };


  const [replacementType, setReplacementType] = useState(null);
  const [adaptor, setAdaptor] = useState(null);
  const [reasonOfReplacement, setReasonOfReplacement] = useState(null);
  const handleReplacementType = (selectedOption) => {
    setReplacementType(selectedOption);
  };

  const handleAdaptor = (selectedOption) => {
    setAdaptor(selectedOption);
  };

  const handleReasonOfReplacement = (selectedOption) => {
    setReasonOfReplacement(selectedOption);
  };

  const handleIconClick = (formId) => {
    setActiveForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };


  const cardStyle = {
    backgroundColor: "#fff",
    padding: "1rem",
    marginBottom: "2rem",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
  };


  const fetchConsumptionERP = async () => {
    setLoading(true);
   
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
   
      const requestData = {
        Action: "getConsumptionERP",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        canID: sessionStorage.getItem("CanId"),
        // canID: "9060885",
        ItemCode: "",
        ItemDesc: "",
        DateOfConsumption: "",
        QtyConsumed: "",
        SerialNo: "",
        LotNo: "",
        CustomerName: "",
      };
   
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });
   
      // Optional: handle non-200 HTTP responses
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
   
      const result = await response.json();
      // console.log("ERP Consumption API Response:", result);
   
      if (result?.Status === "Success" && result?.Response?.Consumption) {
        const consumption = result.Response.Consumption;
   
        let consumptionArray = [];
   
        // CASE 1: API returns an array already
        if (Array.isArray(consumption)) {
          consumptionArray = consumption;
        }
        // CASE 2/3: API returns an object
        else if (consumption && typeof consumption === "object") {
          const keys = Object.keys(consumption).filter((k) => !k.includes("_attr"));
   
          // If it has numeric keys like "0","1","2" => multiple records
          const hasNumericKeys = keys.some((k) => /^\d+$/.test(k));
   
          if (hasNumericKeys) {
            consumptionArray = keys
              .filter((k) => /^\d+$/.test(k))
              .sort((a, b) => Number(a) - Number(b))
              .map((k) => consumption[k]);
          } else {
            // Single record => wrap into array
            consumptionArray = [consumption];
          }
        }
   
        // Normalize fields so UI doesn't break when [] comes
        consumptionArray = consumptionArray.map((row) => ({
          ...row,
          SerialNo: Array.isArray(row?.SerialNo) ? "" : row?.SerialNo ?? "",
          LotNo: Array.isArray(row?.LotNo) ? "" : row?.LotNo ?? "",
          CustomerName: row?.CustomerName ?? "",
          ItemCode: row?.ItemCode ?? "",
          ItemDesc: row?.ItemDesc ?? "",
          DateOfConsumption: row?.DateOfConsumption ?? "",
          QtyConsumed: row?.QtyConsumed ?? "",
          CANID: row?.CANID ?? "",
        }));
   
        setConsumptionData(consumptionArray);
      } else {
        setConsumptionData([]); // clear old data if any
        toast.warning(result?.Message || "Failed to fetch ERP consumption data", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error("Error fetching ERP consumption data:", error);
      setConsumptionData([]);
      toast.error("Error fetching ERP consumption data", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchConsumptionERP();
  }, []);

  const handleReplace = (row) => {
    // console.log("Replace clicked for row:", row);
    setSelectedRow(row);
    setShowReplaceFields(true);
    setIsReplaceClicked(true); // Set flag to indicate Replace button was clicked
    setActiveForm("form1");
    toast.warning("Please select the New Item/Equipment", {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 1500,
    });
    // Scroll to the bottom of the page smoothly
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  // const handleReturn = async (row) => {
  //   try {
  //     setLoading(true);

  //     const apiUrl = process.env.REACT_APP_API_URL;

  //     // 1. Call getItemForDefaultBOQ API using the row's ItemCode.
  //     const getItemPayload = {
  //       Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //       Action: "getItemForDefaultBOQ",
  //       ItemCode: row.ItemCode,
  //     };

  //     const getItemResponse = await fetch(apiUrl, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(getItemPayload),
  //     });

  //     const getItemResult = await getItemResponse.json();
  //     console.log("getItemForDefaultBOQ response:", getItemResult);

  //     if (getItemResult.Status === "Success" && getItemResult.Response) {
  //       const { ItemGUID, SubItemGUID } = getItemResult.Response;

  //       // 2. Prepare values from the row.
  //       const serialNumber = Array.isArray(row.SerialNo)
  //         ? row.SerialNo.length > 0
  //           ? row.SerialNo.join(", ")
  //           : ""
  //         : row.SerialNo || "";

  //       let quantity = row.QtyConsumed || "";
  //       if (quantity !== "") {
  //         const parsedQuantity = parseFloat(quantity);
  //         if (!isNaN(parsedQuantity)) {
  //           // If the number is an integer, convert it without decimals.
  //           quantity = parsedQuantity === Math.floor(parsedQuantity)
  //             ? parsedQuantity.toString()
  //             : parsedQuantity.toString();
  //         }
  //       } const oldFaultyDevice = row.LotNo || "";

  //       // 3. Build the payload for createItemInCRM API.
  //       const createPayload = {
  //         Action: "createItemInCRM",
  //         Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //         srNumber: sessionStorage.getItem("ViewSR"),
  //         canId: sessionStorage.getItem("CanId"),
  //         // srNumber: "SR22082532811",
  //         // canId: "9060885",
  //         userId: "IN\\subhash.kumar",
  //         item: {},
  //         equipment: {},
  //         defaultBOQ: {
  //           ItemType: "Default",
  //           SerialNumber: serialNumber || oldFaultyDevice, // from row.SerialNo if available
  //           Quantity: quantity,   
  //           ItemCodeForBOQ: row.ItemCode,
  //           // from row.QtyConsumed
  //           Item: ItemGUID,             // from getItemForDefaultBOQ response
  //           SubItem: SubItemGUID,       // from getItemForDefaultBOQ response
  //           ConsumptionType: "111260002",
  //           MacId: "",
  //           NRGPSerialNumber: "",
  //           NRGP: "false",
  //           NRGPItem: "",
  //           TemplateID: "",
  //           LocationCode: 111260012,
  //           Adaptor: "111260000",
  //           Reasonofreplacement: "111260000",
  //           Oldfaultydevice: "", // from row.LotNo if available
  //           ReplacementType: "111260001",
  //         },
  //       };

  //       const createResponse = await fetch(apiUrl, {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(createPayload),
  //       });

  //       const createResult = await createResponse.json();
  //       console.log("createItemInCRM response:", createResult);

  //       if (createResult.Status === "Success") {
  //         toast.success("Item Returned in CRM successfully!", {
  //           position: toast.POSITION.BOTTOM_CENTER,
  //           autoClose: 1500,
  //         });
  //       } else {
  //         toast.warning(createResult.Message || "Failed to Returned item in CRM", {
  //           position: toast.POSITION.BOTTOM_CENTER,
  //           autoClose: 1500,
  //         });
  //       }
  //     } else {
  //       toast.warning(getItemResult.Message || "Failed to fetch item for default BOQ", {
  //         position: toast.POSITION.BOTTOM_CENTER,
  //         autoClose: 1500,
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error in Replace process:", error);
  //     toast.error("Error in replacing item", {
  //       position: toast.POSITION.BOTTOM_CENTER,
  //       autoClose: 1500,
  //     });
  //   }
  //   setLoading(false);

  // };


  // Helper function to render a dynamic table in a card.
  const renderTable = (dataArray, title) => {
    if (!dataArray || dataArray.length === 0) {
      return <p>No data available for {title}.</p>;
    }

    // Dynamically extract headers from the first record.
    const headers = Object.keys(dataArray[0]);

    return (
      <div style={cardStyle}>
        <h3 style={{ marginBottom: "1rem" }}>{title}</h3>
        <div style={{ overflowX: "auto" }}>
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead>
              <tr>
                {headers.map((header) => (
                  <th
                    key={header}
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      backgroundColor: "#f2f2f2",
                    }}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {dataArray.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {headers.map((header) => (
                    <td
                      key={header}
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    >
                      {Array.isArray(row[header])
                        ? row[header].join(", ")
                        : row[header]}
                    </td>
                  ))}
                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                    <button onClick={() => handleReplace(row)}
                      className="bg-blue-500 text-black px-3 py-1 rounded hover:bg-blue-700"
                    >Replace</button>
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                    <button onClick={() => handleReturn(row)}
                      className="bg-blue-500 text-black px-3 py-1 rounded hover:bg-blue-700"
                    >Return2</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };



  return (
    <>
      {/* ************************header*********************** */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            style={{ cursor: "pointer" }}
            onClick={redirectDashboardPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">ADD ITEM</span>
        </div>
      </div>
      <Modal show={editModal} onHide={() => setEditModal(false)}>
        <Modal.Header closeButton style={{ backgroundColor: "#9465aa" }}>
          <Modal.Title style={{ color: "#ffffff" }}>Return Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <div className="container shadow mb-3 bg-body rounded mt-4">
              <form className="Installation-form p-2" onSubmit={handleUpdate}>
                <div className="mt-3">
                  <label className="select-search-label mt-2">Adaptor</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="adaptor"
                    placeholder="Select Adaptor"
                    styles={style}
                    isSearchable={false}
                    value={adaptor}
                    onChange={handleAdaptor}
                    options={[
                      { value: "111260000", label: "Yes" },
                      { value: "111260001", label: "No" },
                    ]}
                  />
                </div>
                <div className="mt-3">
                  <label className="select-search-label mt-2">Reason of Replacement</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="reasonOfReplacement"
                    placeholder="Select Reason of Replacement"
                    styles={style}
                    isSearchable={false}
                    value={reasonOfReplacement}
                    onChange={handleReasonOfReplacement}
                    options={[
                      { value: "111260000", label: "OFC Cable Port Damage" },
                      { value: "111260001", label: "Device Faulty - Fan Failure" },
                      { value: "111260002", label: "Device Faulty - Port damage - LAN Output" },
                      { value: "111260003", label: "Device Faulty - No Power on device" },
                      { value: "111260004", label: "Device Faulty - Physical damage/Burnt" },
                      { value: "111260005", label: "Device Faulty - Voltage fluctuations" },
                      { value: "111260006", label: "Device Faulty - Overheating" },
                      { value: "111260007", label: "Environmental issue - temperature extremes" },
                      { value: "111260008", label: "Environmental issue - Dust and Dirt accumulation" },
                      { value: "111260009", label: "Inappropriate Voltage Adapter - Improper power supply" },
                      { value: "111260010", label: "Power Adapters Faulty - Burnt / Damage" },
                      { value: "111260011", label: "Software Issue - Firmware issue/Software Bugs and malware" },
                      { value: "111260012", label: "Software Issue - Configuration issue" },
                      { value: "111260013", label: "Software Issue - IP configuration issue" },
                      { value: "111260014", label: "Software Issue - MAC Authentication issue" },
                      { value: "111260015", label: "Wi-Fi Range issue" },
                    ]}
                  />
                </div>
                <div className="mt-3">
                  <label className="select-search-label mt-2">Store</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="locationCode"
                    placeholder="Select Store"
                    styles={style}
                    isSearchable={false}
                    value={locationCode}
                    onChange={handleLocationChange}
                    options={locationOptions.map((data) => ({
                      value: data.Value,
                      label: data.Text,
                    }))}
                  />
                </div>
                <div className="text-center mt-5 mb-2">
                  <button
                    type="submit"
                    className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* *************************header End*********************** */}

      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={loader} alt="loading...." />
          </div>
        </div>
      ) : (




        <div className="container-fluid" style={{ marginTop: "65px" }}>


          {/* **************Installation Address toggle******************* */}
          <div
            className="contact-toggle"
            onClick={() => handleIconClick("form3")}
          >
            <span className="toggle-text" style={{ fontSize: "20px" }}>Consumption Details</span>

            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>

          </div>

          {activeForm === "form3" && (
            <div
              className="Installation-form p-2"
            // id="form3"
            >
              {/**********Installation Address form******** */}
              {/* <form className="Installation-form p-2" > */}

              <div>
                {loading ? (
                  <p style={{ fontSize: "20px" }}>Loading Consumption Data...</p>
                ) : (
                  <>
                    {/* Display CAN ID and Customer Name only once at the top */}
                    {consumptionData.length > 0 && (
                      <div className="mb-2">
                        <p style={{ fontSize: "20px", fontWeight: "bold" }}>
                          {consumptionData[0].CustomerName} ({consumptionData[0].CANID})
                        </p>
                      </div>
                    )}
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-1">
                      {consumptionData.map((data, index) => (
                        <div key={index} className="col mb-1">
                          <div className="card" style={{ marginBottom: "5px", padding: "8px" }}>
                            <div className="card-body p-2">
                              <p className="mb-1" style={{ fontSize: "20px" }}>
                                Item Code: {data.ItemCode} <br />
                                Description: {data.ItemDesc} <br />
                                Quantity:{" "}
                                {parseFloat(data.QtyConsumed.replace(/,/g, "")).toLocaleString(
                                  "en-US",
                                  { maximumFractionDigits: 0 }
                                )} <br />
                                Serial No/Lot No: {data.LotNo}{data.SerialNo}
                              </p>
                              <div className="d-flex justify-content-center gap-1">
                                <button
                                  className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                                  style={{
                                    width: "90px",
                                    fontSize: "16px",
                                    padding: "6px",
                                    fontWeight: "bold",
                                  }}
                                  onClick={() => handleReplace(data)}
                                >
                                  Replace
                                </button>
                                {/* <button
                                  className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                                  style={{
                                    width: "90px",
                                    fontSize: "16px",
                                    padding: "6px",
                                    fontWeight: "bold",

                                  }}
                                  onClick={() => handleReturn(data)}
                                >
                                  Return
                                </button> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>









              {/* </form> */}
            </div>

          )}




          <div
            className="contact-toggle"
            onClick={() => handleIconClick("form1")}
            style={{ marginTop: "10px", marginBottom: "20px" }}
          >
            <span className="toggle-text" style={{ fontSize: "20px" }}>Additional</span>
            <span className="float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form1" && (
            <div
              className="Installation-form p-2"
              id="form1"
            >
              {/* <form className="Person-Address-form p-3 shadow border rounded"> */}

              {/* <h1 className="p-1 m-3 fw-bold">ERP Consumption Data</h1>

                <div style={{ padding: "1rem" }}> {loading ? (<p>Loading ERP Consumption Data...</p>) : (<div className="row row-cols-1 row-cols-sm-2 row-cols-md-3"> {consumptionData.map((data, index) => (<div key={index} className="col mb-3"> <div className="card"> <div className="card-body"> <p><strong>CAN ID:</strong> {data.CANID}</p> <p><strong>Item Code:</strong> {data.ItemCode}</p> <p><strong>Description:</strong> {data.ItemDesc}</p> <p><strong>Date of Consumption:</strong> {data.DateOfConsumption}</p> <p><strong>Quantity Consumed:</strong> {data.QtyConsumed}</p> <p><strong>Serial No/Lot No:</strong> {data.LotNo}{data.SerialNo}</p> <p><strong>Customer Name:</strong> {data.CustomerName}</p> <div className="d-flex justify-content-center gap-2">
                  <button
                    className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                    style={{ width: "100px" }}
                    onClick={() => handleReplace(data)}
                  >
                    Replace
                  </button>
                  <button
                    className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                    style={{ width: "100px" }}
                    onClick={() => handleReturn(data)}
                  >
                    Return
                  </button>
                </div>
                </div> </div> </div>))} </div>)} </div> */}
              {/* </form> */}
              {/* *********Contact Information form******** */}
              <form className="Person-Address-form p-3 shadow border rounded" >
                {/* <h1 className="p-1 m-3 fw-bold">ADD Item Consumption</h1> */}

                <div>
                  <label className="select-search-label mt-3" >
                    Consumption Type
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="etrReason"
                    placeholder="Select Consumption Type"
                    styles={style}
                    isSearchable={false}
                    value={consumptionType}
                    onChange={handleConsumptionType}
                    options={optionConsumptionType.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>
                {/* <div>
                  <label className="select-search-label mt-2">Item</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="etrReason"
                    placeholder="Select Item"
                    styles={style}
                    isSearchable={false}
                    value={item}
                    onChange={handleItem}
                    options={optionItem.map((data) => ({
                      value: data.item_code,
                      label: data.item_name,
                    }))}
                  />
                </div> */}






                <div>
                  <label className="select-search-label mt-2">Item</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="etrReason"
                    placeholder="Select Item"
                    styles={style}
                    isSearchable={false}
                    value={item}
                    onChange={handleItem}
                    options={optionItem.map((data) => ({
                      value1: data.Itemcode,
                      value: data.item_code, // Ensure this matches the ERP <Item_No>
                      label: data.item_name,
                    }))}
                  />
                </div>

                
                <div>
                  <label className="select-search-label mt-2">Sub Item</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="etrReason"
                    placeholder="Select Sub Item"
                    styles={style}
                    isSearchable={false}
                    value={subItem}
                    onChange={handleSubItem}
                    options={optionSubItem.map((data) => ({
                      value1: data.Itemcode,
                      value: data.sub_item_code,
                      label: data.sub_item_name,
                    }))}
                  />
                </div>

                <div className="input-box form-floating">
                  <input
                    // type="tel"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="quantity"
                    name="quantity"
                    value={addItemData.quantity}
                    // maxLength="10"
                    // pattern="[0-9]{10}"
                    onChange={handleChange}
                  // onKeyDown={(e) => {
                  //   const allowedKeys = [
                  //     "Backspace",
                  //     "Delete",
                  //     "ArrowLeft",
                  //     "ArrowRight",
                  //     "Tab",
                  //   ];
                  //   const isDigit = /\d/.test(e.key);
                  //   if (isDigit || allowedKeys.includes(e.key)) {
                  //     return true;
                  //   } else {
                  //     e.preventDefault();
                  //   }
                  // }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Quantity
                  </label>
                </div>

                {/* <div className="mt-3">
                  <label className="select-search-label mt-2">Serial No./Lot No.</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="serialNo"
                    placeholder="Select Serial/Lot No."
                    styles={style}
                    isSearchable={false}
                    value={selectedSerial}
                    onChange={setSelectedSerial}
                    options={serialOptions}
                  />
                </div> */}
                <div className="mt-3">
                  <label className="select-search-label mt-2">Serial No./Lot No.</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="serialNo"
                    placeholder="Select Serial/Lot No."
                    styles={style}
                    isSearchable={false}
                    value={selectedSerial}
                    onChange={setSelectedSerial}
                    options={[...serialOptions, { value: "NA", label: "NA" }]}
                  />
                </div>





                {/* <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="serialNo"
                    name="serialNo"
                    value={addItemData.serialNo}
                    onChange={(e) =>
                      setAddItemData((prev) => ({ ...prev, serialNo: e.target.value }))
                    }
                  />
                  <label htmlFor="serialNo" className="mt-2">
                    Serial No./Lot No.
                  </label>
                </div> */}
                {/* <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="serialNo"
                    name="serialNo"
                    value={addItemData.serialNo}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Serial No./Lot No.
                  </label>
                </div> */}
                {/* <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="macId"
                    name="macId"
                    value={addItemData.macId}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    MAC ID
                  </label>
                </div>
                <div>
                  <label className="select-search-label mt-2">NRGP Item</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="etrReason"
                    placeholder="Select NRGP Item"
                    styles={style}
                    isSearchable={false}
                    value={nrgpItem}
                    isDisabled={true}
                    onChange={handleNrgpItem}
                    options={optionNrgpItem.map((data) => ({
                      value: data.NRGPItem,
                      label: data.NRGPItemID,
                    }))}
                  />
                </div>
                <div>
                  <label className="select-search-label mt-2">
                    NRGP SubItem
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="etrReason"
                    placeholder="Select NRGP SubItem"
                    styles={style}
                    isSearchable={false}
                    value={nrgpSubItem}
                    onChange={handleNrgpSubItem}
                    isDisabled={true}
                    options={optionNrgpSubItem.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="nrgp"
                    name="nrgp"
                    value={addItemData.nrgp}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    NRGP
                  </label>
                </div>
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="nrgpSerialNum"
                    name="nrgpSerialNum"
                    value={addItemData.nrgpSerialNum}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    NRGP Serial Number
                  </label>
                </div> */}

                {/* ===== New Fields Start ===== */}
                {/* <div className="mt-4">
                  <label className="select-search-label mt-2">
                    Replacement Type
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="replacementType"
                    placeholder="Select Replacement Type"
                    styles={style}
                    isSearchable={false}
                    value={replacementType}
                    onChange={handleReplacementType}
                    options={[
                      { value: "111260000", label: "Replace" },
                      { value: "111260001", label: "Return" },
                    ]}
                  />
                </div> */}

                <div className="mt-3">
                  <label className="select-search-label mt-2">Adaptor</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="adaptor"
                    placeholder="Select Adaptor"
                    styles={style}
                    isSearchable={false}
                    value={adaptor}
                    onChange={handleAdaptor}
                    options={[
                      { value: "111260000", label: "Yes" },
                      { value: "111260001", label: "No" },
                    ]}
                  />
                </div>

                {/* <div className="mt-3">
                  <label className="select-search-label mt-2">
                    Reason of Replacement
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="reasonOfReplacement"
                    placeholder="Select Reason of Replacement"
                    styles={style}
                    isSearchable={false}
                    value={reasonOfReplacement}
                    onChange={handleReasonOfReplacement}
                    options={[
                      { value: "111260000", label: "Faulty" },
                      { value: "111260001", label: "Replace" },
                      { value: "111260002", label: "Deactivate" },
                      { value: "111260003", label: "NA" },
                    ]}
                  />
                </div>
            
                <div className="input-box form-floating mt-3">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="FaultyDevice"
                    name="FaultyDevice"
                    value={addItemData.FaultyDevice}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                  Old Faulty Device Serial No	
                  </label>
                </div> */}
                {showReplaceFields && (
                  <>
                    <div className="mt-3">
                      <label className="select-search-label mt-2">Reason of Replacement</label>
                      <Select
                        className="basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        name="reasonOfReplacement"
                        placeholder="Select Reason of Replacement"
                        styles={{ /* your style object */ }}
                        isSearchable={false}
                        value={reasonOfReplacement}
                        onChange={handleReasonOfReplacement}
                        options={[
                          { value: "111260000", label: "OFC Cable Port Damage" },
                          { value: "111260001", label: "Device Faulty - Fan Failure" },
                          { value: "111260002", label: "Device Faulty - Port damage - LAN Output" },
                          { value: "111260003", label: "Device Faulty - No Power on device" },
                          { value: "111260004", label: "Device Faulty - Physical damage/Burnt" },
                          { value: "111260005", label: "Device Faulty - Voltage fluctuations" },
                          { value: "111260006", label: "Device Faulty - Overheating" },
                          { value: "111260007", label: "Environmental issue - temperature extremes" },
                          { value: "111260008", label: "Environmental issue - Dust and Dirt accumulation" },
                          { value: "111260009", label: "Inappropriate Voltage Adapter - Improper power supply" },
                          { value: "111260010", label: "Power Adapters Faulty - Burnt / Damage" },
                          { value: "111260011", label: "Software Issue - Firmware issue/Software Bugs and malware" },
                          { value: "111260012", label: "Software Issue - Configuration issue" },
                          { value: "111260013", label: "Software Issue - IP configuration issue" },
                          { value: "111260014", label: "Software Issue - MAC Authentication issue" },
                          { value: "111260015", label: "Wi-Fi Range issue" },
                          { value: "111260016", label: "Device working replaced due to customer consent" },
                          { value: "111260017", label: "Device working replaced due to NOC recommendation" }
                        ]}
                      />
                    </div>

                    {/* <div className="input-box form-floating mt-3">
                      <input
                        type="text"
                        placeholder=""
                        className="form-control input-text form-control-sm mt-1"
                        id="FaultyDevice"
                        name="FaultyDevice"
                        value={addItemData.FaultyDevice}
                        onChange={handleChange}
                      />
                      <label htmlFor="FaultyDevice" className="mt-2">
                        Old Faulty Device Serial No
                      </label>
                    </div> */}


                    <div className="mt-3">
                      <label className="select-search-label mt-2">Reason Type</label>
                      <Select
                        className="basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        name="reasonType"
                        placeholder="Select Reason Type"
                        styles={style}
                        isSearchable={false}
                        value={reasonType}
                        onChange={handleReasonType}
                        options={options}
                      />
                    </div>
                  </>
                )}



                <div className="mt-3">
                  <label className="select-search-label mt-2">Store</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="locationCode"
                    placeholder="Select Store"
                    styles={style}
                    isSearchable={false}
                    value={locationCode}
                    onChange={handleLocationChange}
                    options={locationOptions.map((data) => ({
                      value: data.Value,
                      label: data.Text,
                    }))}
                  />
                </div>


                {/* <div className="input-box form-floating mt-3">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="locationCode"
                    name="locationCode"
                    value={addItemData.locationCode}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Location Code
                  </label>
                </div> */}
                {/* ===== New Fields End ===== */}

                <div className="text-center mt-5 mb-2">
                  <button
                    type="button"
                    className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                    onClick={handleCreateEquipment1}
                  >
                    ADD
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      )}
    </>
  );

};

export default YourAssignmentAddItem;
